// ResetButtonState.js
import { useState } from 'react';

let isResetButtonPressed = false;

const setIsResetButtonPressedValue = (value) => {
  isResetButtonPressed = value;
};

const getIsResetButtonPressed = () => {
  return isResetButtonPressed;
};

export { setIsResetButtonPressedValue, getIsResetButtonPressed };